import { render } from "./DashboardOfferSidebar.vue?vue&type=template&id=6add4232&scoped=true"
import script from "./DashboardOfferSidebar.vue?vue&type=script&lang=ts"
export * from "./DashboardOfferSidebar.vue?vue&type=script&lang=ts"

import "./DashboardOfferSidebar.vue?vue&type=style&index=0&id=6add4232&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6add4232"

export default script